export default class MultiLevel {
    constructor(app) {
        this.app = app;

        /** @type int Displayed rows */
        this.rows = this.rowCount() > 0 ? this.rowCount() : 1;

    }

    /**
     * Total elements
     * @returns int
     */
    elementCount() {
        return Object.keys(
            this.app.currentConfiguration.mainElementParameters
        ).length;
    }

    maxColumns() {
        if (this.app.currentConfiguration.familyParameters.gama.value.id == '66')
            return 2;

        return 1;
    }

    maxRows() {
        let gama = this.app.currentConfiguration.familyParameters.gama.value.id;

        if (gama == '66') {
            return 5;
        } else if (gama == '67') { return 5; }

        return 1;
    }

    canAddRow() {
        console.warn(this.rowCount());

        if (this.rows >= this.maxRows()) {
            return false
        }
        if (this.rows > this.rowCount()) {
            return false
        }

        return true;
    }

    canRemoveRow() {
        if (this.rowCount() >= this.rows) {
            return false;
        }
        if (this.rows > 1) {
            return true
        }
        return false
    }
    addRow() {
        this.rows++;
    }

    async removeRow() {
        if (this.rowCount() >= this.rows) {
            await this.app.asyncModal(
                app.translate("popup_S3_remove_row_warning"),
                false
            );

        } else {
            this.rows--
        }
    }

    rowCount() {
        let result = 0;

        Object.keys(this.app.currentConfiguration.
            mainElementParameters).
            forEach((key) => {
                let keyArray = key.split('-');
                let keyRow = parseInt(keyArray[0]);

                if (keyRow > result) {
                    result = keyRow;
                }
            });

        return result;
    }

    columnCount() {
        let sol_constructiva = this.app.currentConfiguration.familyParameters.sol_constructiva.value.id;

        if( sol_constructiva == "10-t_sop")
            return 2;

        return 1
    }

    async addElement(row = null, column = null) {
        // if (column == null) {
        //     // Default column: 1
        //     column = 1;
        // }

        if (row == null) {
            // Gets first row available in selected column
            row = this.getFirstRowAvailable(column);
        }

        let newElementKey = row + (column == null ? "" : "-" + column);

        await this.app.API.addMainElement(newElementKey);
    }

    canRemoveElement(row, column = null) {

        // console.warn("Row: " + row + ", Column: " + column + ", Rows: " + this.rows + ", rowCount: " + this.rowCount())
        // Verificar que existeix
        if (!this.existsElement(row, column))
            return false

        // Una sola columna, es pot esborrar qualsevol
        if (column == null)
            return true

        // A la ultima fila, sempre es pot
        if (row == Math.max(this.rows, this.rowCount()))
            return true

        if (Math.max(this.rows, this.rowCount()) > 1) {
            // Verificar que si es borra un element no queda la fila buida
            if (column == 1 && !this.existsElement(row, 2))
                return false;

            if (column == 2 && !this.existsElement(row, 1))
                return false;

            // Una sola columna
            // if (row < Math.max(this.rows, this.rowCount()))
            //     return false;
        }

        return true;
    }
    async removeElement(row, column = null) {
        // if (column == null) {
        //     // Default column: 1
        //     column = 1;
        // }

        let elementKey = row + (column == null ? "" : "-" + column);
        // let elementKey = row + "-" + column;
        await this.removeElementByKey(elementKey);

    }
    renameElements() {
        let newKey = 0;

        Unex.log("Renaming mainElements","Configurator")

        Object.entries(
            this.app.currentConfiguration.mainElementParameters
        ).forEach(([key, value]) => {
            newKey += 1;
            if (
                this.app.currentConfiguration.mainElementParameters.hasOwnProperty(
                    key
                )
            ) {
                delete this.app.currentConfiguration.mainElementParameters[
                    key
                ];
                this.app.currentConfiguration.mainElementParameters[
                    newKey
                ] = value;
            }
        });
    }

    async removeElementByKey(key) {
        Unex.log("Trying to remove element with key '" + key + "'", "MultiLevel")

        delete this.app.currentConfiguration.mainElementParameters[
            key
        ];

        if( this.columnCount() == 1)
            this.renameElements()
        // console.warn(this.app.currentConfiguration.mainElementParameters)
        // await this.app.asyncProcess(false, false);

    }

    getFirstRowAvailable(column) {
        let rowKeys = this.getRowKeys(column);
        let availableRow = 0;

        rowKeys.forEach((value, index) => {
            if (index > value) {
                availableRow = index;
            }
        });

        if (availableRow == 0) {
            return rowKeys.length + 1;
        }
    }
    getRowKeys(column) {
        let result = [];

        Object.keys(this.app.currentConfiguration.
            mainElementParameters).
            forEach((key) => {
                let keyArray = key.split('-');
                let keyRow = parseInt(keyArray[0]);
                let keyColumn = 1;

                if (keyArray.length > 1) {
                    // Multi column
                    keyColumn = keyArray[1];

                    if (keyColumn == column) {
                        result.push(keyRow);
                    }
                } else {
                    // One column
                    result.push(keyRow);
                }

            });

        return result;
    }

    getElementKey(row, column = 1) {
        let elementKey = row + "-" + column;

        return elementKey;
    }
    getElement(row, column = 1) {
        return this.getElementByKey(this.getElementKey(row, column));
    }
    getElementByKey(key) {
        if (this.existsKey(key)) {
            return this.app.currentConfiguration.
                mainElementParameters[key]
        }
    }

    existsElement(row, column = null) {
        let elementKey = row + (column == null ? "" : "-" + column);
        return this.existsKey(elementKey);
    }

    existsKey(key) {
        let result = this.app.currentConfiguration.
            mainElementParameters.hasOwnProperty(key);

        return result;
    }
}

